<script setup>
  import { computed, inject, onMounted } from 'vue'
  import { sortStandingEntries } from '@/services/utils'
  import StandingsTable from './StandingsTable.vue'

  const tournament = inject('tournament')
  const allEntries = inject('allEntries')

  defineEmits(['remove-from-group'])

  const group_entries = defineModel('group_entries', { type: Array, default: () => [] })

  const fullDataEntries = computed(() => {
    const tournamentEntries = allEntries.value
    return group_entries.value ? group_entries.value.map(entry => {
      const playerData = tournamentEntries[entry.entry_id]
      const { id, ...playerDataWithoutId } = playerData || {}
      return { ...entry, ...playerDataWithoutId }
    }) : []
  })

  const sortEntries = () => {
    if (!group_entries.value) {
      return
    }

    group_entries.value = sortStandingEntries(
      group_entries.value,
      tournament.value,
      allEntries?.value ?? {}
    )
  }

  onMounted(() => {
    sortEntries()
  })

  defineExpose({ sortEntries })
</script>

<template>

  <StandingsTable
    v-model:group_entries="group_entries"
    :full-data-entries="fullDataEntries"
    @remove-from-group="$emit('remove-from-group', $event)"
  />

  <div v-if="!group_entries || group_entries.length === 0" class="pa-4">
    No entries.
  </div>

</template>